var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"menu"},[_c('v-flex',{attrs:{"lg12":"","md12":"","xs12":""}},[_c('v-card',[_c('f-transaction-list-stepper',{attrs:{"productId":_vm.productId,"productGroup":_vm.productGroup,"transactionForm":_vm.transactionForm}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }